import React from 'react';
import { View, Text, StyleSheet, FlatList } from 'react-native';
import EventItem from './EventItem';
import { Card } from '../../cards';
import colors from '../../../config/colors';

/**
 * EventFeed - Scrollable list of pump events
 * Shows recent pump activity and alerts
 */
function EventFeed({
    events = [],
    maxHeight = 300,
    onViewAllPress,
}) {
    const renderItem = ({ item }) => (
        <EventItem
            type={item.type}
            timestamp={item.timestamp}
            duration={item.duration}
            power={item.power}
            interval={item.interval}
            isAlert={item.isAlert}
        />
    );

    const keyExtractor = (item, index) => item.id || `event-${index}`;

    return (
        <Card style={styles.container}>
            <Text style={styles.title}>Recent Activity</Text>
            {events.length > 0 ? (
                <View style={[styles.listContainer, { maxHeight }]}>
                    <FlatList
                        data={events}
                        renderItem={renderItem}
                        keyExtractor={keyExtractor}
                        showsVerticalScrollIndicator={true}
                        nestedScrollEnabled={true}
                    />
                </View>
            ) : (
                <View style={styles.emptyContainer}>
                    <Text style={styles.emptyText}>No recent events</Text>
                </View>
            )}
            {onViewAllPress && events.length > 0 && (
                <Text style={styles.viewAll} onPress={onViewAllPress}>
                    View All Events
                </Text>
            )}
        </Card>
    );
}

const styles = StyleSheet.create({
    container: {
        padding: 0,
        overflow: 'hidden',
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        color: colors.dark,
        padding: 16,
        paddingBottom: 8,
    },
    listContainer: {
        overflow: 'hidden',
    },
    emptyContainer: {
        padding: 32,
        alignItems: 'center',
    },
    emptyText: {
        color: colors.medium,
        fontSize: 14,
    },
    viewAll: {
        color: colors.primary,
        fontSize: 14,
        fontWeight: '500',
        textAlign: 'center',
        padding: 12,
        borderTopWidth: 1,
        borderTopColor: '#f0f0f0',
    },
});

export default EventFeed;
